import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { Card } from "antd";
import UserLayout from "components/layout/UserLayout";
import UserNavs from "components/users/UserNavs";
import UserCommentItem from "components/user/UserCommentItem";
import EmptyList from "components/app/EmptyList";
import Loading from "components/app/Loading";
import Pager from "components/site/Pager";
import UserDetailBlock from "components/users/UserDetailBlock";

import { getUserComments } from "redux/actions/user";
import { getUser, getUserV2 } from "redux/actions/user";

const Page = ({
  token,
  currentUser,
  userCommentList,
  getUserComments,
}: {
  token: any;
  currentUser: any;
  userCommentList: any;
  getUserComments: any;
}) => {
  const router = useRouter();
  const { page = 1, id } = router.query;
  const { comments = [], pager } = userCommentList || {};
  const [user, setUser] = useState<any>();

  const handleFetch = (page: any) => {
    getUserComments({ page, user_id: id });
  };

  useEffect(() => handleFetch(page), []);
  useEffect(() => {
    const action: any = token ? getUserV2(token, id) : getUser(id);
    action.then((user: any) => {
      setUser(user);
    });
  }, [token]);

  return (
    user && (
      <UserLayout
        pageTitle={`用户 ${user.nickname}`}
        user={user}
        currentUser={currentUser}
      >
        <UserDetailBlock user={user} />
        <Card>
          <UserNavs user={user} activeKey="replies" />
          {userCommentList ? (
            comments.length ? (
              comments.map((comment: any) => (
                <UserCommentItem comment={comment} key={comment.id} />
              ))
            ) : (
              <EmptyList />
            )
          ) : (
            <Loading />
          )}
          <Pager pager={pager} onPageChange={handleFetch} />
        </Card>
      </UserLayout>
    )
  );
};

const mapStateToProps = (state: any) => ({
  token: state.user.token,
  currentUser: state.user.user,
  userCommentList: state.user.userCommentList,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators({ getUserComments }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Page);
